export const EMPTY_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=' // (!!)

export const PRODUCT_CARD_ID_PREFIX = 'product-card-'
export const DEFAULT_IMAGE_SIZE = '390'
export const MOBILE_IMAGE_SIZE = '600'
export const IMAGE_SIZE = '740'
export const REPLACEMENT_PRODUCT_CODE_KEY = 'replacement_product_code'
export const REPLACEMENT_PRODUCT_CODENTIFY_KEY = 'replacement_product_codentify'
